import { setUser } from '@sentry/react';
import { Hub } from 'aws-amplify/utils';
import { amplifyConfigure } from '@/amplify/amplify-configure.ts';
import { isOnlineVar } from '@/components/network-status.ts';
import { shutdownIntercomSession } from '@/intercom';
import {
  getApolloClient,
  setApolloClient,
} from './apollo/apollo-client-instance.ts';
import { makeApolloClient } from './apollo/apollo-client.ts';
import { invalidateSession } from './routes-utils/handle-authorized-data.ts';

let init = false;

export const setupAppGlobals = async () => {
  if (!init) {
    amplifyConfigure();

    setApolloClient(makeApolloClient());

    Hub.listen('auth', async ({ payload }) => {
      if (payload.event === 'signedOut') {
        invalidateSession();
        window.mixpanel?.reset();
        shutdownIntercomSession();
        setUser(null);
        await getApolloClient().clearStore();
      }
    });

    window.addEventListener('online', () => isOnlineVar(true));
    window.addEventListener('offline', () => isOnlineVar(false));

    init = true;
  }

  return;
};
